import { PWA_INSTALL_DISMISSAL_STORAGE_KEY } from "@/lib/pwaInstallStorage";

export function writePwaInstallDismissedUntil(
  dismissedUntil: number,
  storage?: Pick<Storage, "setItem">,
): void {
  try {
    const target = storage ?? (typeof window === "undefined" ? null : window.localStorage);
    if (!target) return;

    target.setItem(PWA_INSTALL_DISMISSAL_STORAGE_KEY, String(dismissedUntil));
  } catch {
    // Installation remains available when browser storage is unavailable.
  }
}
